<template>
<!-- 个人中心页面 -->
  <div class="content">
    <div class="information">
      <div class="infor_left">
        <img src="../../assets/img/avatarIco.png" alt="">
      </div>
      <div class="infor_right">
        <ul class="new_ul">
          <li>
            <span>{{ $t('app.userAccount.info.name') }}：</span>
            <span>{{datalist.company}}</span>
          </li>
          <li>
            <span class="tip"><el-tooltip :content="$t('app.userAccount.tooltip.balance')" placement="top" effect="light"><i class="el-icon-question"></i></el-tooltip></span>
            <span>{{ $t('app.userAccount.info.balance') }}：</span> 
            <span style="color:#ff0000">¥</span>
            <span style="color:#ff0000">{{ datalist.availAmount}}</span>
            <span style="color:#ff0000;margin-left:5%;cursor:pointer" @click="accountDetails" v-hasPermi="['person:userAccount:outInPay']">{{ $t('app.userAccount.action.details') }} ></span>
            <span style="color:#ff0000;margin-left:5%;cursor:pointer" @click="onlinepay" v-hasPermi="['person:userAccount:pay']">{{ $t('app.userAccount.action.recharge') }} ></span>
          </li>
          <li>
            <span class="tip"><el-tooltip :content="$t('app.userAccount.tooltip.phone')" placement="top" effect="light"><i class="el-icon-question"></i></el-tooltip></span>
            <span>{{ $t('app.userAccount.info.phone') }}：</span>
            <span>{{datalist.phone}}</span>
            <span style="color:#ff0000;margin-left:4%;cursor:pointer" v-hasPermi="['person:userAccount:bindPhone']" @click="binDing(datalist.phone)">{{ $t('app.userAccount.action.bind') }} ></span>
          </li>
          <li v-hasPermi="['person:userAccount:open:renewal']">
            <span>{{ $t('app.userAccount.info.autoRenewal') }}：</span>
            <el-switch
              v-model="datalist.autoRenewal"
              active-color="#13ce66"
              inactive-color="#DCDFE6"
              active-value="1"
              inactive-value="0"
              @change="renewChange($event)"
            ></el-switch>
          </li>
          <li>
            <el-button type="primary" plain size="mini" icon="el-icon-circle-plus" @click="onlinepay" v-hasPermi="['person:userAccount:pay']">{{ $t('app.userAccount.button.rechargeNow') }}</el-button>
            <el-button type="primary" plain size="mini" icon="el-icon-crop" @click="bindWechat" v-hasPermi="['person:userAccount:bindwx']"  v-if="datalist.bindWeiXin == '0'">{{ $t('app.userAccount.button.bindWechat') }}</el-button>
          </li>
        </ul>
      </div>
      <div class="authentication">
        <i></i>
        <p v-if="datalist.kycStatus == '0'" style="color:#e6a23c">{{ $t('app.userAccount.authStatus.unverified') }}</p>
        <p v-if="datalist.kycStatus == '1'" style="color:#e6a23c">{{ $t('app.userAccount.authStatus.pending') }}</p>
        <p v-if="datalist.kycStatus == '2'" style="color:#67c23a">{{ $t('app.userAccount.authStatus.verified') }}</p>
        <p v-if="datalist.kycStatus == '3'" style="color:#f56c6c">{{ $t('app.userAccount.authStatus.failed') }}</p>
        <el-button type="primary" v-hasPermi="['person:userAccount:authentication']"  @click="authenticationBind" v-if="datalist.kycStatus == '0' ">{{ $t('app.userAccount.button.goAuth') }}</el-button>
        <el-button type="primary" v-hasPermi="['person:userAccount:authentication']"  @click="authenticationBind" v-else-if="datalist.kycStatus == '3' "> {{ $t('app.userAccount.button.reAuth') }}</el-button>
        <el-button type="success" v-hasPermi="['person:userAccount:authentication']"  @click="authenticationInfo" v-else>{{ $t('app.userAccount.button.authInfo') }}</el-button>
      </div>
    </div>
    <div>
      <tabList></tabList>
    </div>
    <el-dialog :title="$t('app.userAccount.dialog.bindWechatTitle')" :visible.sync="dialogVisible" width="350px" class="dialogclass" @close="dialogClose">
      <img :src="imgSrc" alt="" class="wximg">
    </el-dialog>
    <el-dialog :title="$t('app.userAccount.dialog.autoRenewTitle')" :visible.sync="renewDialog" :lock-scroll="false" width="450px" v-dialogDrag>
      <p>{{ $t('app.userAccount.dialog.autoRenewItem1') }}</p>
      <p>{{ $t('app.userAccount.dialog.autoRenewItem2') }}</p>
      <p>{{ $t('app.userAccount.dialog.autoRenewItem3') }}</p>
      <div class="dialog-footer" slot="footer">
        <el-button type="success" @click="automaticDialog">{{ $t('app.common.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {createQrCodeBindWx, userInfo} from "@/api/api.js";//获取个人中心的信息
import { result } from "@/api/api.js";//微信扫码绑定查询状态
import { autoRenewal } from "@/api/api.js";//个人中心的自动续费开关
import tabList from "@/views/scale/tabList.vue";
export default {
  data() {
    return {
      activeName:"first",
      datalist:{},
      imgSrc:'',
      dialogVisible: false,
      timer:null,
      types:[],
      renewDialog:false,
    };
  },
  components: {
    tabList
  },
  computed: {},
  // 监听路由离开的操作
  beforeRouteLeave(to, form, next) {
    clearInterval(this.timer);
    this.timer = null;
    next()
  },
  methods: {
    // 金额的千分位展示
    numFormat(num){
      var res=num.toString().replace(/\d+/, function(n){ // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
          return $1+",";
        });
      })
      return res;
    },
    // 初始化信息
    initData() {
      let params = {
				userId: localStorage.getItem("userId")
			};
      userInfo(params).then(res => {
        if (res.data.code == 200) {
          this.datalist = res.data.data;
          this.datalist.availAmount = this.numFormat(res.data.data.availAmount);
        }
      })
    },
    // 自动续费的弹窗
    renewChange(val){
      if(val == 1){
        this.renewDialog = true;
        this.datalist.autoRenewal = false
      }else{
        let params = {
          renewal:"0"
        };
        autoRenewal(params).then(res=>{
          if(res.data.code == 200){
            this.initData()
          }
        })
      }
    },
    // 自动续费的保存
    automaticDialog(){
      let params = {
        renewal:"1"
      };
      autoRenewal(params).then(res=>{
        if(res.data.code == 200){
          this.renewDialog = false;
          this.initData()
        }
      })
    },
    
    //去实名认证
    authenticationBind(){
      this.$router.push('/user/authentication')
    },
    //实名信息详情
    authenticationInfo(){
      this.$router.push("/user/authenticationInfo");
    },
    // 跳转到明细
    accountDetails(){
      this.$router.push("/user/accountList");
    },
    // 更换手机号
    binDing(phone){
      this.$router.push("/user/bindPhone/" + phone);
    },
    // 去充值页面
    onlinepay(){
      this.$router.push("/user/pay");
    },
    // 绑定微信
    bindWechat(){
      this.dialogVisible = true;
      createQrCodeBindWx({orderId:this.orderId }).then(res=>{
        this.imgSrc = "data:image/jpeg;base64," + res.data.data;
      })
      this.timer = setInterval(() => {
        result().then(res => {
          if (res.data.code == 200) {
            clearInterval(this.timer);
            this.timer = null;
            this.dialogVisible = false
          }
        })
      },2000)
    },
    // 关闭微信绑定的弹窗
    dialogClose(){
      this.dialogVisible = false;
      clearInterval(this.timer);
      this.timer = null;
    },
  },
  mounted() {
    this.initData();
  },
  created() {
    
  }
};
</script>
<style scoped lang="less">
body {
  margin-left: calc(100vw - 100%);
}
.content{
  width: 100%;
}
.checkedClass{
  display: inline-block;
  text-align: center;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  line-height: 16px;
  background: rgb(253, 136, 60);
  color: rgb(255, 255, 255) !important;
  transform: scale(0.833333);
  margin-left: 5px;
}
.information{
  width: 100%;
  height: 220px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #eee;;
}
.infor_left img{
  width: 175px;
  height: 175px;
}
.infor_right{
  margin-left: 2%;
  // width: 350px;
}
.new_ul li{
  height: 40px;
  line-height: 40px;
  width: 120%;
}
.new_ul li span{
  font-size: 14px;
  color: #666;
  cursor: pointer;
}
/deep/ .el-tabs__item{
  font-size: 16px;
  height: 50px;
  line-height: 50px;
}
/deep/ .el-date-editor .el-range-separator{
  width: 6%;
}
.authentication{
  margin-left: 3%;
}
.authentication p{
  text-align: center;
  width: 200px;
  height: 48px;
  line-height: 48px;
}
.authentication i{
  width: 65px;
  margin: 0 auto;
  height: 48px;
  display: block;
  background: url(../../assets/img/newGreen_certif.png)no-repeat;
}
.authentication button{
  width: 200px;
  margin-top: 5px;
}
.wximg{
  width: 200px;
  height: 200px;
  position: relative;
  left: 50px;
}
.el-select{
  width: 200px;
}
.el-button{
  margin: 3px 3px;
}
/deep/ .el-tabs__item{
  font-size:14px
}
.tip{
  position: absolute;
  margin-left: -15px;
}
</style>


